import React from 'react';
import { Row } from 'reactstrap';
import { InputLabel } from './ProofOfDocument';
import { observer } from 'mobx-react-lite';
import { createWrapperFieldRenderer } from '../../helpers/createWrapperFieldRenderer';
import { setValue, shouldShowField } from '../../../../../components/InputField/helper';
const ACCESS_TYPES = [{
  id: 0,
  type: "Viewer",
  text: "View payments and create new beneficiaries."
}, {
  id: 1,
  type: "Basic User",
  text: "All access of Viewer and initiate new payments. Payments initiated by basic users will require authorisation from owner (or) approver (or) a power user before the payment is submitted for further processing. Basic user cannot authorise payments."
}, {
  id: 2,
  type: "Approver",
  text: "All access of Basic User and approve payments initiated by others. Approver’s own initiated transactions will require authorisation from another Approver, Power User or Owner."
}, {
  id: 3,
  type: "Power User",
  text: "Same access as Owner"
}];
const User = ({
  setCentralErrors,
  asLabel,
  data,
  hasError,
  index,
  validationkeyValue,
  handleChangeViaObject
}) => {
  const renderWrapperField = createWrapperFieldRenderer({
    fieldMap: validationkeyValue,
    dataObj: data,
    disabled: asLabel,
    showError: hasError,
    defaultOnChange: handleChangeViaObject,
    defaultOnError: (value, fieldPath) => {
      if (!fieldPath) return;
      setCentralErrors(prevErrors => ({
        ...prevErrors,
        [fieldPath.replace(/\[\d+\]/g, '[]')]: value
      }));
    }
  });
  const individual = data?.individuals?.[index] || {};
  const isShareHolder = Boolean(individual?.isShareHolder);
  const isAuthorizedUser = Boolean(individual?.isAuthorizedUser);
  const shouldShowIndependentDirector = !isShareHolder && !isAuthorizedUser;
  const persistRoleToggleObject = (nextData, fieldName) => {
    let updatedData = nextData;
    const person = updatedData?.individuals?.[index];
    if (person && (fieldName === 'isShareHolder' || fieldName === 'isAuthorizedUser') && person?.[fieldName] === true) {
      updatedData = setValue(updatedData, `individuals[${index}].isIndependentDirector`, false, false);
    }
    const updatedPerson = updatedData?.individuals?.[index];
    if (fieldName === 'isAuthorizedUser' && updatedPerson?.isAuthorizedUser === true && !updatedPerson?.accessType) {
      updatedData = setValue(updatedData, `individuals[${index}].accessType`, 'NoGroup', false);
    }
    if (fieldName === 'isShareHolder' && updatedPerson?.isShareHolder !== true) {
      updatedData = setValue(updatedData, `individuals[${index}].percentOwner`, null, false);
    }
    handleChangeViaObject(updatedData);
  };
  const applyNestedUpdates = (nextData, updates = []) => {
    if (!updates.length) {
      handleChangeViaObject(nextData);
      return;
    }
    const patchedData = updates.reduce((draft, {
      fieldPath,
      value
    }) => setValue(draft, fieldPath, value, false), nextData);
    handleChangeViaObject(patchedData);
  };
  const shouldShowIndividualDetails = shouldShowField(data, validationkeyValue?.['individuals[].firstName']?.showIf, index);
  const shouldShowRelationshipFields = shouldShowField(data, validationkeyValue?.['individuals[].haveControlOverEntity']?.showIf, index) || shouldShowField(data, validationkeyValue?.['individuals[].isDirector']?.showIf, index);
  const shouldShowAuthorizedOnlyFields = shouldShowField(data, validationkeyValue?.['individuals[].isAuthorizedContact']?.showIf, index) || shouldShowField(data, validationkeyValue?.['individuals[].isAgentWithAttorneyPower']?.showIf, index);
  return <div className='mt-2'>

    {renderWrapperField('individuals[].isShareHolder', {
      key: `individuals[].isShareHolder-${index}`,
      arrayIndexing: index,
      customProp: true,
      onChange: nextData => persistRoleToggleObject(nextData, 'isShareHolder')
    })}

    {renderWrapperField('individuals[].isAuthorizedUser', {
      key: `individuals[].isAuthorizedUser-${index}`,
      arrayIndexing: index,
      disabled: asLabel || index == 0,
      customProp: index !== 0,
      onChange: nextData => persistRoleToggleObject(nextData, 'isAuthorizedUser')
    })}

    {shouldShowIndependentDirector ? renderWrapperField('individuals[].isIndependentDirector', {
      key: `individuals[].isIndependentDirector-${index}`,
      arrayIndexing: index,
      customProp: true
    }) : null}

    <div style={shouldShowIndividualDetails ? undefined : {
      display: 'none'
    }} aria-hidden={!shouldShowIndividualDetails}>
      <InputLabel required label={"Name"} labelStyle={{
        fontSize: 15
      }} />
      <p className='ps-2 ms-0 mb-0' style={{ fontSize: 11, fontStyle: 'italic' }}>
        Please enter your name exactly as it appears on your passport.
      </p>
      <Row>
        {renderWrapperField('individuals[].firstName', {
          key: `individuals[].firstName-${index}`,
          arrayIndexing: index,
          className: 'col-sm-4'
        })}
        {renderWrapperField('individuals[].middleName', {
          key: `individuals[].middleName-${index}`,
          arrayIndexing: index,
          className: 'col-sm-4'
        })}
        {renderWrapperField('individuals[].lastName', {
          key: `individuals[].lastName-${index}`,
          arrayIndexing: index,
          className: 'col-sm-4'
        })}
      </Row>

      <InputLabel required label={"Address"} labelStyle={{
        fontSize: 15
      }} />
      <Row>
        {renderWrapperField('individuals[].address.street', {
          key: `individuals[].address.street-${index}`,
          arrayIndexing: index
        })}
      </Row>
      <Row>
        {renderWrapperField('individuals[].address.buildingNumber', {
          key: `individuals[].address.buildingNumber-${index}`,
          arrayIndexing: index
        })}
      </Row>
      <Row>
        {renderWrapperField('individuals[].address.city', {
          key: `individuals[].address.city-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6 col-md-3'
        })}
        {renderWrapperField('individuals[].address.state', {
          key: `individuals[].address.state-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6 col-md-3'
        })}

        {renderWrapperField('individuals[].address.pinCode', {
          key: `individuals[].address.pinCode-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6 col-md-3',
          onError: errorMsg => {
            setCentralErrors(prevErrors => ({
              ...prevErrors,
              'individuals[].address.pinCode': errorMsg
            }));
          }
        })}

        {renderWrapperField('individuals[].address.country', {
          key: `individuals[].address.country-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6  col-md-3  with-margin-top',
          onChange: nextData => {
            const nextCountry = nextData?.individuals?.[index]?.address?.country;
            const hasUsTie = ["US", "USA"].includes(nextCountry) || ["US", "USA"].includes(nextData?.individuals?.[index]?.nationality);
            applyNestedUpdates(nextData, !hasUsTie ? [{
              fieldPath: `individuals[${index}].ssn`,
              value: null
            }] : []);
          }
        })}

      </Row>

      <Row>
        {renderWrapperField('individuals[].dob', {
          key: `individuals[].dob-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6'
        })}

        <div className="col-12 col-sm-6">
          {renderWrapperField('individuals[].nationality', {
            key: `individuals[].nationality-${index}`,
            arrayIndexing: index,
            onChange: nextData => {
              const nextNationality = nextData?.individuals?.[index]?.nationality;
              const nextCountryOfIssuance = nextData?.individuals?.[index]?.countryOfIssuance;
              const hasUsTie = ["US", "USA"].includes(nextNationality) || ["US", "USA"].includes(nextData?.individuals?.[index]?.address?.country);
              const updates = [];
              if (!nextCountryOfIssuance) {
                updates.push({
                  fieldPath: `individuals[${index}].countryOfIssuance`,
                  value: nextNationality
                });
              }
              if (!hasUsTie) {
                updates.push({
                  fieldPath: `individuals[${index}].ssn`,
                  value: null
                });
              }
              applyNestedUpdates(nextData, updates);
            }
          })}
        </div>


        {renderWrapperField('individuals[].email', {
          key: `individuals[].email-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6',
          disabled: asLabel || index == 0
        })}

        {renderWrapperField('individuals[].mobilePhone', {
          key: `individuals[].mobilePhone-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6 mt-2',
          onError: v => {
            setCentralErrors(prevErrors => ({
              ...prevErrors,
              [`individuals[].mobilePhone`]: v
            }));
          },
          customProp: {
            individual_id: data?.individuals?.[index]?._id,
            validateOnly: !data?.individuals?.[index]?.isAuthorizedUser
          }
        })}




        {renderWrapperField('individuals[].taxId', {
          key: `individuals[].taxId-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6'
        })}

        {renderWrapperField('individuals[].countryOfIssuance', {
          key: `individuals[].countryOfIssuance-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6'
        })}




        {renderWrapperField('individuals[].role', {
          key: `individuals[].role-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6'
        })}

        {renderWrapperField('individuals[].accessType', {
          key: `individuals[].accessType-${index}`,
          arrayIndexing: index,
          className: 'col-12 col-sm-6',
          disabled: asLabel || index == 0
        })}

        {data?.individuals?.[index]?.isAuthorizedUser ? <div>
          {ACCESS_TYPES.map(e => <div className='my-2 ps-2 fs-6' key={e.id}><span className="bold-text">{e.type}: </span>{e.text}</div>)}
        </div> : null}


        {renderWrapperField('individuals[].Mother_Maiden_Name', {
          key: `individuals[].Mother_Maiden_Name-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6'
        })}

      </Row>

      <Row>
        {renderWrapperField('individuals[].percentOwner', {
          key: `individuals[].percentOwner-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6',
          requiredOverride: isShareHolder
        })}


        {renderWrapperField('individuals[].ssn', {
          key: `individuals[].ssn-${index}`,
          arrayIndexing: index,
          className: 'col-sm-6 mt-0'
        })}
      </Row>

      <div className='mt-3' style={shouldShowRelationshipFields ? undefined : {
        display: 'none'
      }} aria-hidden={!shouldShowRelationshipFields}>
        {renderWrapperField('individuals[].haveControlOverEntity', {
          key: `individuals[].haveControlOverEntity-${index}`,
          arrayIndexing: index,
          disabled: asLabel
        })}

        {renderWrapperField('individuals[].isDirector', {
          key: `individuals[].isDirector-${index}`,
          arrayIndexing: index,
          jsonField: validationkeyValue?.['individuals[].isDirector']
        })}

      </div>

      <div style={shouldShowAuthorizedOnlyFields ? undefined : {
        display: 'none'
      }} aria-hidden={!shouldShowAuthorizedOnlyFields}>
        {renderWrapperField('individuals[].isAuthorizedContact', {
          key: `individuals[].isAuthorizedContact-${index}`,
          arrayIndexing: index
        })}

        {renderWrapperField('individuals[].isAgentWithAttorneyPower', {
          key: `individuals[].isAgentWithAttorneyPower-${index}`,
          arrayIndexing: index
        })}
      </div>

      {renderWrapperField('individuals[].sourceOfWealthList', {
        key: `individuals[].sourceOfWealthList-${index}`,
        arrayIndexing: index,
        requiredOverride: isShareHolder
      })}
    </div>
  </div>;
};
export default observer(User);
